// src/redux/services/paymentApi.js
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseUrl = process.env.REACT_APP_BASE_API_URL;

export const paymentApi = createApi({
  reducerPath: 'paymentApi',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState }) => {
      const user = getState().auth?.user;
      if (user?.token) {
        headers.set('authorization', `${user.token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    // Fetch all payment methods
    getPaymentMethods: builder.mutation({
      query: () => ({
        url: 'payment_methods',
        method: 'GET',
      }),
    }),

    // Edit an existing payment method
    editPaymentMethod: builder.mutation({
      query: ( body ) => ({
        url: `payment_methods`,
        method: 'PUT',
        body: body,
      }),
    }),

    // Add a new payment method
    addPaymentMethod: builder.mutation({
      query: ( body ) => ({
        url: 'payment_methods',
        method: 'POST',
        body: body,
      }),
    }),

    // Delete a payment method by ID
    deletePaymentMethod: builder.mutation({
      query: (id) => ({
        url: `payment_methods/${id}`,
        method: 'DELETE',
      }),
    }),

    sendPayment: builder.mutation({
      query: (body) => ({
        url: `payments/session/make-payment`,
        method: 'POST',
        body: {...body, 
          source: "app"
        }
      //   body: {
      //     "token": "card_1Pw4OMEZeAgSQHW5LTmR7yQD",
      //     "source": "app",
      //     "amount": "100",
      //     "payment_method": "card",
      //     "venue_id": 32,
      //     "booth_id": 75,
      //     "session_id": 85542,
      //     "venue_stripe_account_id": "acct_1LX9XiLAkzKmyET6",
      //     "stripe_customer": "cus_Os8gH5MpO8svgr"
      // }
      }),
    }),
  }),
});

export const {
  useGetPaymentMethodsMutation,
  useEditPaymentMethodMutation,
  useAddPaymentMethodMutation,
  useDeletePaymentMethodMutation,
  useSendPaymentMutation,
} = paymentApi;
